import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=2acb7569&scoped=true&"
import script from "./BankInfo.vue?vue&type=script&lang=js&"
export * from "./BankInfo.vue?vue&type=script&lang=js&"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=2acb7569&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb7569",
  null
  
)

export default component.exports